export const DEFAULT_REFERRAL_POST_BOOKING_CTA_CONFIG = {
  enabled: false,
} as const;
